import React, {useEffect, useState} from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Fab,
  makeStyles,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';

import {cloneDeep} from 'lodash';
import propTypes from 'prop-types';

import RowContent from '../row-content';
import UpdateGenreDialog from './update-genre-panel';

import {assetsTableStylesObject} from '../../helpers/tools';

const useStyles = makeStyles(() => assetsTableStylesObject);

const UpdateAssetDialog = ({isOpen, handleUpdate, handleCancel, recordToUpdate}) => {
  const classes = useStyles();

  const [isUpdatingGenres, setIsUpdatingGenres] = useState();
  const [updateRecordCopy, setUpdateRecordCopy] = useState({});
  const [ruidsToDelete, setRuidsToDelete] = useState([]);

  useEffect(() => {
    setRuidsToDelete([]);
    setUpdateRecordCopy({});
    if (isOpen && recordToUpdate) {
      setUpdateRecordCopy(cloneDeep(recordToUpdate));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const onGenresSelection = selected => {
    const record = {...updateRecordCopy};
    const tempGenres = [...record?.genres];
    if (selected?.category?.toLowerCase() === record?.category?.toLowerCase()) {
      tempGenres.push(selected?.genre);
      record.aliases = [...new Set([...record.aliases, ...selected?.aliases])];
      record.genres = [...new Set(tempGenres)];
    } else {
      record.category = selected?.category;
      record.aliases = selected?.aliases;
      record.genres = [selected?.genre];
    }
    setUpdateRecordCopy(record);
    setIsUpdatingGenres(false);
  };

  const handleMarkDPForDeletion = dataPackage => {
    const foundRuid = ruidsToDelete.find(ruid => ruid === dataPackage.dataPackageId);

    setRuidsToDelete(prev => {
      if (foundRuid) {
        return prev.slice().filter(ruid => ruid !== dataPackage.dataPackageId);
      }
      return [...prev, dataPackage.dataPackageId];
    });
  };

  const handleGenreChipDelete = (genre, key) => () =>
    setUpdateRecordCopy(prev => {
      const updatedRecord = {...prev};
      const genresCollectionCopy = [...updatedRecord.genres];
      updatedRecord.aliases = updatedRecord?.aliases?.filter(
        alias => alias?.genreName?.toLowerCase() !== genre?.name?.toLowerCase()
      );
      genresCollectionCopy.splice(key, 1);
      updatedRecord.genres = genresCollectionCopy;

      return updatedRecord;
    });

  const renderGenresChips = (rowGenres = []) =>
    rowGenres.map((genre, key) => (
      <Chip
        color="secondary"
        key={key}
        label={genre?.strValue}
        style={{padding: 2, margin: 5, fontSize: 15}}
        onDelete={handleGenreChipDelete(genre, key)}
      />
    ));

  return (
    <>
      <Dialog fullWidth={true} maxWidth="md" open={isOpen} onClose={handleCancel}>
        <DialogTitle>Update Asset</DialogTitle>
        <DialogContent>
          <DialogContentText style={{fontSize: 13}}>
            <>
              <div className={classes.rowDiv}>
                <h4 className={classes.rowHeaderDisabled}>Echostar ID</h4>
                <span className={classes.rowCellDisabled}>{updateRecordCopy?.echostarId}</span>
              </div>
              <div className={classes.rowDiv}>
                <h4 className={classes.rowHeaderDisabled}>Name</h4>
                <span className={classes.rowCellDisabled}>{updateRecordCopy?.name}</span>
              </div>
              <div className={classes.rowDiv}>
                <h4 className={classes.rowHeader}>Genres</h4>
                {renderGenresChips(updateRecordCopy?.genres)}
                <Fab
                  className={classes.margin}
                  color="primary"
                  size="medium"
                  onClick={() => {
                    setIsUpdatingGenres(true);
                  }}
                >
                  <AddIcon />
                </Fab>
              </div>
              <RowContent
                echostarId={updateRecordCopy.echostarId}
                isUpdating={isOpen}
                rowContent={updateRecordCopy}
                ruidsToDelete={ruidsToDelete}
                onDeleteDp={handleMarkDPForDeletion}
              />
            </>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button
            color="primary"
            onClick={() => {
              handleUpdate(updateRecordCopy, ruidsToDelete);
            }}
          >
            Update
          </Button>
        </DialogActions>
      </Dialog>
      {isUpdatingGenres && (
        <UpdateGenreDialog
          assetToUpdate={updateRecordCopy}
          handleClose={() => setIsUpdatingGenres(false)}
          isOpen={isUpdatingGenres}
          onGenresSelection={onGenresSelection}
        />
      )}
    </>
  );
};

export default UpdateAssetDialog;

UpdateAssetDialog.propTypes = {
  handleCancel: propTypes.func,
  handleUpdate: propTypes.func,
  isOpen: propTypes.bool,
  recordToUpdate: propTypes.object,
};
